import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';

const Loader = (props) => {
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden'
      }}
    >
      <CircularProgress
        className={props.extraClass}
        size={props.size}
        color={props.color}
      />
    </div>
  );
};

Loader.propTypes = {
  size: PropTypes.number,
  extraClass: PropTypes.string,
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary'])
};

Loader.defaultProps = {
  size: 16,
  extraClass: '',
  color: 'inherit'
};

export default Loader;
